<template>
  <div>
    <div
      v-if="value"
      class="icon"
      :class="`has-text-${trueType}`"
    >
      <i
        class="mdi"
        :class="`mdi-${trueIcon}`"
      />
    </div>
    <div
      v-else
      class="icon"
      :class="`has-text-${falseType}`"
    >
      <i
        class="mdi"
        :class="`mdi-${falseIcon}`"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Boolean
    },
    trueIcon: {
      default: "check-circle",
      type: String
    },
    trueType: {
      default: "success",
      type: String
    },
    falseIcon: {
      default: "close",
      type: String
    },
    falseType: {
      default: "grey",
      type: String
    },
  }
};
</script>
